import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation, {
    ExistingUser,
    ReturnToProduct
} from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";

import { SubHeading, WelcomeBackHeading } from "../../components";

export const CurrentProductUser = () => (
    <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
        <WelcomeBackHeading />
        <SubHeading>
            <FormattedMessage
                id="return-to-product-modal.header.text"
                defaultMessage="Pick up where you left off."
            />
        </SubHeading>
        {/* everyone with a teamwork collection should see a return to product experience */}
        <SiteActivation
            CurrentProductUser={
                <ReturnToProduct
                    ExistingUser={<ExistingUser SitePicker={null} />}
                />
            }
        />
    </SignupBackgroundLayout>
);
